import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { v4 as uuidv4 } from 'uuid';

export const MobileProductCardSkeleton = ({ ColourId }) => (
	<li className="flex flex-col xs:px-2 w-full" data-lazy-sku={ColourId}>
		<div className="bg-white rounded-lg h-full">
			<div className="p-2 pb-0">
				<div className="flex flex-col justify-between p-2 pl-0">
					<Skeleton height={40} width="30%" />
					<Skeleton />
					<Skeleton width="40%" />
					<Skeleton height={120} className="my-4" />
				</div>
				<div className="p-2 pr-0">
					{new Array(5).fill(0).map(() => (
						<React.Fragment key={uuidv4()}>
							<Skeleton />
							<Skeleton width="50%" />
						</React.Fragment>
					))}
				</div>
				<Skeleton width="60%" />
				<div className="flex mx-2 mt-2">
					<div className="w-full mr-3">
						<Skeleton count={3} />
					</div>
					<div className="w-full ml-3">
						<Skeleton count={2} />
					</div>
				</div>
			</div>

			<div className="flex p-2 pb-2">
				<div className="w-full">
					<Skeleton height={40} className="mr-1" />
				</div>
				<div className="w-full">
					<Skeleton height={40} className="ml-1" />
				</div>
			</div>

			<div className="flex my-2">
				<div className="w-full px-10">
					<Skeleton />
				</div>
			</div>
		</div>
	</li>
);

export default MobileProductCardSkeleton;
